import { Component, OnInit } from '@angular/core';
import { EditorService } from '../../../editor.service';
@Component({
  selector: 'app-shapecolor',
  templateUrl: './shapecolor.component.html',
  styleUrls: ['./shapecolor.component.css']
})
export class ShapecolorComponent implements OnInit {

  constructor(private editorService: EditorService) { }

  ngOnInit() {
  }


  changepageColor(clr) {
    let layer = this.editorService.getIframeReference();
    layer.changeShapeColor(clr);
  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/text/shapecolor/shapecolor.component.ts